import { createAsyncThunk } from '@reduxjs/toolkit';
import { API_RESPONSE } from '../../constants';

export const createAsyncThunkWrapper = (actionType, apiFunction) => {
  return createAsyncThunk(actionType, async (body, { rejectWithValue }) => {
    try {
      const response = await apiFunction(body);
      if(response.status === API_RESPONSE.NO_CONTENT){
        return null;
      } 
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  });
};
